/**
 * Formats a numeric reading together with its unit for display or export,
 * e.g. `1002.5 hPa`, `0 hPa`, or `5` when no unit is known.
 *
 * `0` is a legitimate value (a lower threshold, for instance) and is kept;
 * only `null`, `undefined` and `NaN` yield an empty string. Pass a locale to
 * format the number for display (`1.002,5` in German); omit it for
 * machine-readable output such as CSV, where `1002.5` stays parseable.
 */
export const formatValueWithUnit = (
    value: number | null | undefined,
    unit?: string | null,
    locale?: string,
): string => {
    if (value == null || Number.isNaN(value)) return "";
    const formatted = locale ? value.toLocaleString(locale) : String(value);
    return unit ? `${formatted} ${unit}` : formatted;
};
